var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoScissorsSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12h24v24H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.005 16.87a3.75 3.75 0 0 1 6.816 3.012l-.018.053.956.553 1.564.902.122-.112a5.048 5.048 0 0 1 1.608-.953l.257-.085 5.325-1.628a5.25 5.25 0 0 1 2.893-.051l.803.215a.75.75 0 0 1 .181 1.374L27.842 24l6.67 3.85a.75.75 0 0 1-.072 1.337l-.109.037-.802.215a5.25 5.25 0 0 1-2.893-.05l-5.325-1.628a5.05 5.05 0 0 1-1.866-1.04l-.123-.112-1.55.895-.013.008-.95.549.054.168a3.75 3.75 0 0 1-.24 2.697l-.111.209a3.75 3.75 0 1 1-.496-4.412l.036.042.957-.551.012-.01.112-.071a1.42 1.42 0 0 0 .574-.974l.01-.148c.008-.412.063-.813.165-1.201l-.045.19-.023-.103a5.078 5.078 0 0 1-.082-.6l-.015-.307a1.42 1.42 0 0 0-.709-1.204l-.949-.548-.083.093a3.75 3.75 0 0 1-2.504 1.18l-.224.006a3.75 3.75 0 0 1-3.243-5.646zm5.11 11.124a2.25 2.25 0 1 0 .086.135l-.086-.135zm7.227-3.128-1.636.944.009.007c.25.179.523.325.813.434l.22.075 5.326 1.629c.252.077.51.127.77.15l.118.005-5.62-3.244zm5.618-4.976-.116.006a3.75 3.75 0 0 0-.77.15l-5.327 1.629a3.55 3.55 0 0 0-1.707 1.138 3.553 3.553 0 0 0-.813 2.008l-.006.114 2.747-1.585 5.992-3.46zm-13.595-3.071a2.25 2.25 0 1 0 .831 3.06l.074-.142a2.25 2.25 0 0 0-.905-2.918z",
    fill: "#979797",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoScissorsSquare);
export default __webpack_public_path__ + "static/media/ico-scissors-square.127c5f00f581e9c86d1c0d848db0b2ce.svg";
export { ForwardRef as ReactComponent };